import React from 'react';
import MinorCategories from '../../minorcategories';

export default class HeaderPanelBottom extends React.Component {
  static propTypes = {
    panels: React.PropTypes.object.isRequired
  };

  componentDidUpdate (prevProps) {
    if (this.props.activeCategory) {
      document.querySelectorAll('h3.header__panel__title a').forEach(link => {
        link.checkVisibility() && link.focus();
      });
    }
    else if (prevProps.activeCategory) {
      // Focus the first visible link in the major categories .. not sure if we can focus on the one which initiated this dialog
      document.querySelectorAll('button.majorcategories__link').forEach(link => {
        link.checkVisibility() && link.focus();
      });
    }
  }


  render () {
    var content = '';
    if (this.props.panels.bot === 'category') {
      content = <MinorCategories {...this.props} />;
    }

    let activeCategoryName = '';
    if (this.props.activeCategory) {
      activeCategoryName = this.props.categories.find(category => category.id === this.props.activeCategory).name;
    } 

    return (
      <div
        className="header__panel--bottom"
        role="dialog"
        closedby="any"
        aria-label={activeCategoryName || 'none'}
      >
        {content}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/panels/bottom/index.js